import FormOrgGroupAssignment from "../components/ui/form-org-group-assignment.js";
import CurrentOrgRequired from "../components/ui/current-org-required.js";


export default function ManageOrgGroupAssignmentPage() {
  return (
    <CurrentOrgRequired>
      <FormOrgGroupAssignment/>
    </CurrentOrgRequired>
  );
}